<template>
  <div class="flex flex-col items-center w-full px-4 py-4 text-sm text-gray-500 justify-center mx-auto">
    <div class="flex items-center justify-between space-x-2">
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasPreviousPage"
              @click="listCollectionData(listApi['list'], $emit, authToken, paginate.page-1, optionalParams['orderBy'], optionalParams['order'], optionalParams['criterion'], optionalParams['search'], optionalParams['where'], optionalParams['isPaginate'], optionalParams['customQuery']);">
        Anterior
      </button>
      <div class="flex flex-row space-x-1">
        <button type="button"
                :class="'flex px-2 py-px '+(paginate.page===page?'text-white bg-blue-400 border border-blue-400':'border border-blue-400 hover:bg-blue-400 hover:text-white')"
                v-for="(page, index) in displayedPages" :key="index"
                @click="listCollectionData(listApi['list'], $emit, authToken, page, optionalParams['orderBy'], optionalParams['order'], optionalParams['criterion'], optionalParams['search'], optionalParams['where'], optionalParams['isPaginate'], optionalParams['customQuery']);">
          {{ page }}
        </button>
      </div>
      <button type="button" class="hover:text-gray-600" v-if="paginate.hasNextPage"
              @click="listCollectionData(listApi['list'], $emit, authToken,  paginate.page+1,optionalParams['orderBy'], optionalParams['order'], optionalParams['criterion'], optionalParams['search'], optionalParams['where'], optionalParams['isPaginate'], optionalParams['customQuery']);">
        Siguiente
      </button>
    </div>
  </div>
</template>

<script>

import {listCollectionData} from "@/layouts/main";

/**
 * Componente de paginación para listar colecciones de datos
 *
 * @vue-prop {Function} listar - Función para listar la colección de datos
 * @vue-prop {String} authToken - Token de autenticación para la API
 * @vue-prop {Object} paginate - Objeto con información sobre la paginación
 * @vue-prop {Object} optionalParams - Objeto con parámetros opcionales para la consulta
 * @vue-emit {Function} updateValues - Evento que se emite cuando se actualizan los valores de la paginación
 */
export default {
  name: "PaginateRefactComponent",
  props: ['authToken', 'listApi', 'paginate', 'optionalParams'],
  emits: ["updateValues"],
  data: function () {
    return {
      /**
       * Método que se ejecuta al hacer clic en los botones de paginación.
       * Llama a la función de listar con los parámetros correspondientes.
       *
       * @param {String} action - Acción a realizar (anterior o siguiente)
       * @param {Number} page - Página a la que se quiere acceder
       */
       listCollectionData: listCollectionData,
       showAllPages: false,
    };
  },
  computed: {
    displayedPages() {
      const pageCount = this.paginate.pageCount;
      if (this.showAllPages) {
        return Array.from({ length: pageCount }, (_, index) => index + 1);
      } else {
        const maxPagesToShow = 7;
        const currentPage = this.paginate.page;
        const middlePage = Math.floor(maxPagesToShow / 2);
        const startPage = Math.max(1, currentPage - middlePage);
        const endPage = Math.min(pageCount, startPage + maxPagesToShow - 1);
        return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
      }
    },
  },
};
</script>